import React from "react";
import { connect } from "react-redux";
import { Grid, Paper } from "@material-ui/core";
import { useStyles } from "../../src/pages/dashboard/planner/Style"
import clsx from "clsx"

const JumbotronComponent = ({ notPlanner, fullname, description }) => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  return (
    <div>
       <Grid item xs={12} md={12} lg={12}>
        <Paper className={`${fixedHeightPaper} justify-content-center`}>
          <h1 className="text-center text-capitalize">Welcome, {fullname}!</h1>
          <p className="text-center">
            {description}
          </p>
        </Paper>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fullname: state.login.fullname,
  };
};

export default connect(mapStateToProps, null)(JumbotronComponent);
